import { createAction, props } from '@ngrx/store';
import { ShipperClaim, ShipperClaimListResponse, ShipperClaimFilter, ShipperClaimEmail, ShipperClaimUpdateSummaryWithGeminiDto } from '../../data/interfaces';

// Load Shipper Claims List
export const loadShipperClaims = createAction(
    '[Shipper Claims] Load Shipper Claims',
    props<{ filter: ShipperClaimFilter }>()
);

export const loadShipperClaimsSuccess = createAction(
    '[Shipper Claims] Load Shipper Claims Success',
    props<{ shipperClaims: ShipperClaimListResponse }>()
);

export const loadShipperClaimsFailure = createAction(
    '[Shipper Claims] Load Shipper Claims Failure',
    props<{ error: string }>()
);

// Load Single Shipper Claim
export const loadShipperClaim = createAction(
    '[Shipper Claims] Load Shipper Claim',
    props<{ shipperClaimId: string }>()
);

export const loadShipperClaimSuccess = createAction(
    '[Shipper Claims] Load Shipper Claim Success',
    props<{ shipperClaim: ShipperClaim }>()
);

export const loadShipperClaimFailure = createAction(
    '[Shipper Claims] Load Shipper Claim Failure',
    props<{ error: string }>()
);

// Create Shipper Claim
export const createShipperClaim = createAction(
    '[Shipper Claims] Create Shipper Claim',
    props<{ shipperClaim: Partial<ShipperClaim> }>()
);

export const createShipperClaimSuccess = createAction(
    '[Shipper Claims] Create Shipper Claim Success',
    props<{ shipperClaim: ShipperClaim }>()
);

export const createShipperClaimFailure = createAction(
    '[Shipper Claims] Create Shipper Claim Failure',
    props<{ error: string }>()
);

// Update Shipper Claim
export const updateShipperClaim = createAction(
    '[Shipper Claims] Update Shipper Claim',
    props<{ shipperClaimId: string; updates: Partial<ShipperClaim> }>()
);

export const updateShipperClaimSuccess = createAction(
    '[Shipper Claims] Update Shipper Claim Success',
    props<{ shipperClaim: ShipperClaim }>()
);

export const updateShipperClaimFailure = createAction(
    '[Shipper Claims] Update Shipper Claim Failure',
    props<{ error: string }>()
);

// Add Email to Claim
export const addEmailToClaim = createAction(
    '[Shipper Claims] Add Email to Claim',
    props<{ shipperClaimId: string; email: Partial<ShipperClaimEmail> & { files?: File[]; carrierOnly?: boolean } }>()
);

export const addEmailToClaimSuccess = createAction(
    '[Shipper Claims] Add Email to Claim Success',
    props<{ shipperClaim: ShipperClaim }>()
);

export const addEmailToClaimFailure = createAction(
    '[Shipper Claims] Add Email to Claim Failure',
    props<{ error: string }>()
);

// Update Email
export const updateEmail = createAction(
    '[Shipper Claims] Update Email',
    props<{ shipperClaimId: string; emailId: string; email: Partial<ShipperClaimEmail> & { carrierOnly?: boolean } }>()
);

export const updateEmailSuccess = createAction(
    '[Shipper Claims] Update Email Success',
    props<{ shipperClaim: ShipperClaim }>()
);

export const updateEmailFailure = createAction(
    '[Shipper Claims] Update Email Failure',
    props<{ error: string }>()
);

// Delete Shipper Claim
export const deleteShipperClaim = createAction(
    '[Shipper Claims] Delete Shipper Claim',
    props<{ shipperClaimId: string }>()
);

export const deleteShipperClaimSuccess = createAction(
    '[Shipper Claims] Delete Shipper Claim Success',
    props<{ shipperClaimId: string }>()
);

export const deleteShipperClaimFailure = createAction(
    '[Shipper Claims] Delete Shipper Claim Failure',
    props<{ error: string }>()
);

// Delete Email from Claim
export const deleteEmailFromClaim = createAction(
    '[Shipper Claims] Delete Email from Claim',
    props<{ shipperClaimId: string; emailId: string }>()
);

export const deleteEmailFromClaimSuccess = createAction(
    '[Shipper Claims] Delete Email from Claim Success',
    props<{ shipperClaim: ShipperClaim }>()
);

export const deleteEmailFromClaimFailure = createAction(
    '[Shipper Claims] Delete Email from Claim Failure',
    props<{ error: string }>()
);

// Mark Email as Read
export const markEmailAsRead = createAction(
    '[Shipper Claims] Mark Email as Read',
    props<{ shipperClaimId: string; emailId: string }>()
);

export const markEmailAsReadSuccess = createAction(
    '[Shipper Claims] Mark Email as Read Success',
    props<{ shipperClaim: ShipperClaim }>()
);

export const markEmailAsReadFailure = createAction(
    '[Shipper Claims] Mark Email as Read Failure',
    props<{ error: string }>()
);

// Mark All Emails as Admin Read
export const markAllEmailsAdminRead = createAction(
    '[Shipper Claims] Mark All Emails as Admin Read',
    props<{ shipperClaimId: string }>()
);

export const markAllEmailsAdminReadSuccess = createAction(
    '[Shipper Claims] Mark All Emails as Admin Read Success',
    props<{ shipperClaim: ShipperClaim | null }>()
);

export const markAllEmailsAdminReadFailure = createAction(
    '[Shipper Claims] Mark All Emails as Admin Read Failure',
    props<{ error: string }>()
);

// Toggle Email Visibility
export const toggleEmailVisibility = createAction(
    '[Shipper Claims] Toggle Email Visibility',
    props<{ shipperClaimId: string; emailId: string; showEmail: boolean }>()
);

export const toggleEmailVisibilitySuccess = createAction(
    '[Shipper Claims] Toggle Email Visibility Success',
    props<{ shipperClaim: ShipperClaim }>()
);

export const toggleEmailVisibilityFailure = createAction(
    '[Shipper Claims] Toggle Email Visibility Failure',
    props<{ error: string }>()
);

// Get Shipper Claim Stats
export const loadShipperClaimStats = createAction(
    '[Shipper Claims] Load Shipper Claim Stats'
);

export const loadShipperClaimStatsSuccess = createAction(
    '[Shipper Claims] Load Shipper Claim Stats Success',
    props<{ stats: any }>()
);

export const loadShipperClaimStatsFailure = createAction(
    '[Shipper Claims] Load Shipper Claim Stats Failure',
    props<{ error: string }>()
);

// Update Summary with Gemini
export const updateSummaryWithGemini = createAction(
    '[Shipper Claims] Update Summary with Gemini',
    props<{ shipperClaimId: string; geminiDto: ShipperClaimUpdateSummaryWithGeminiDto }>()
);

export const updateSummaryWithGeminiSuccess = createAction(
    '[Shipper Claims] Update Summary with Gemini Success',
    props<{ shipperClaim: ShipperClaim }>()
);

export const updateSummaryWithGeminiFailure = createAction(
    '[Shipper Claims] Update Summary with Gemini Failure',
    props<{ error: string }>()
);

// Download a specific email's attachments as ZIP
export const downloadShipperClaimEmailAttachments = createAction(
    '[Shipper Claims] Download Shipper Claim Email Attachments',
    props<{ shipperClaimId: string; emailId: string }>()
);

export const downloadShipperClaimEmailAttachmentsSuccess = createAction(
    '[Shipper Claims] Download Shipper Claim Email Attachments Success'
);

export const downloadShipperClaimEmailAttachmentsFailure = createAction(
    '[Shipper Claims] Download Shipper Claim Email Attachments Failure',
    props<{ error: string }>()
);
